<header class="flex shrink-0">
  <div
    class="flex flex-col w-full bg-navy-900 h-12"
    [class]="layout.darkHeader() ? '' : 'border-b border-surface-300'"
  >
    <div
      [class]="layout.darkHeader() ? 'bg-navy-900' : 'bg-white/90'"
      class="w-full rounded-tl-4xl mt-4 px-4 sm:px-10 py-4 flex items-center justify-between h-21 shrink-0 backdrop-blur-sm"
    >
      <!-- Title + Breadcrumb (with mobile back arrow) -->
      <div class="flex items-center gap-3">
        @if (layout.showBackButton()) {
          <button
            (click)="goBack()"
            class="sm:hidden flex items-center justify-center w-8 h-8 rounded-full hover:bg-surface-100 transition-colors cursor-pointer shrink-0"
            [class.text-white]="layout.darkHeader()"
            aria-label="Go back"
          >
            <img src="/icons/arrow-left-icon.svg" class="w-5 h-5" alt="" />
          </button>
        }
        <div class="flex" [class]="layout.switchPlaces() ? 'flex-col-reverse' : 'flex-col'">
          <div class="flex flex-col">
            <h1
              [class.text-white]="layout.darkHeader()"
              class="text-base font-bold text-navy-600 leading-5"
            >
              {{ layout.title() }}
            </h1>
            <h2
              [class.text-white]="layout.darkHeader()"
              class="text-base font-bold text-navy-600 leading-5"
            >
              {{ layout.title2() }}
            </h2>
          </div>
          @if (layout.breadcrumb()) {
            <p
              [class.text-white]="layout.darkHeader()"
              class="font-normal text-sm leading-4 text-slate-500 mb-0.5"
            >
              {{ layout.breadcrumb() }}
            </p>
          }
        </div>
      </div>

      <!-- Actions -->
      <div class="hidden md:flex items-center md:gap-10">
        @if (layout.showBackButton()) {
          <button
            (click)="goBack()"
            class="flex items-center gap-2 text-sm text-slate-500 hover:text-navy-600 transition-colors cursor-pointer"
          >
            <img src="/icons/arrow-left-icon.svg" class="w-4 h-4" alt="" />
            <span class="ml-2"> {{ layout.backLabel() }}</span>
          </button>
        }

        @if (layout.headerAction()) {
          <button
            (click)="layout.headerAction()!.onClick()"
            class="flex items-center gap-2 text-sm text-slate-600 bg-surface-100 hover:text-navy-600 border border-surface-300 rounded-lg px-8 py-3 hover:bg-surface-100 transition-colors cursor-pointer"
          >
            @switch (layout.headerAction()!.icon) {
              @case ('search') {
                <img src="/icons/search-icon.svg" class="w-4 h-4" alt="" />
              }
              @case ('plus') {
                <img src="/icons/plus-icon.svg" class="w-4 h-4" alt="" />
              }
            }
            {{ layout.headerAction()!.label }}
          </button>
        }
      </div>
      <!-- Hamburger — mobile only -->
      <button
        class="sm:hidden flex flex-col gap-1.5 p-2 text-navy-600 cursor-pointer"
        (click)="layout.mobileOpen.set(!layout.mobileOpen())"
        aria-label="Open navigation"
      >
        <span class="block w-5 h-0.5 bg-current rounded"></span>
        <span class="block w-5 h-0.5 bg-current rounded"></span>
        <span class="block w-3.5 h-0.5 bg-current rounded"></span>
      </button>
    </div>
    <!-- Actions for mobile -->
    <div
      class="md:hidden flex items-center gap-10 justify-between p-4"
      [class]="layout.darkHeader() ? 'bg-navy-900' : 'bg-white/90'"
    >
      @if (layout.showBackButton()) {
        <button
          (click)="goBack()"
          class="flex items-center gap-2 text-sm text-slate-500 hover:text-navy-600 transition-colors cursor-pointer"
        >
          <img src="/icons/arrow-left-icon.svg" class="w-4 h-4" alt="" />
          <span class="ml-2"> {{ layout.backLabel() }}</span>
        </button>
      }

      @if (layout.headerAction()) {
        <button
          (click)="layout.headerAction()!.onClick()"
          class="flex items-center gap-2 text-sm text-slate-600 bg-surface-100 hover:text-navy-600 border border-surface-300 rounded-lg px-8 py-3 hover:bg-surface-100 transition-colors cursor-pointer"
        >
          @switch (layout.headerAction()!.icon) {
            @case ('search') {
              <img src="/icons/search-icon.svg" class="w-4 h-4" alt="" />
            }
            @case ('plus') {
              <img src="/icons/plus-icon.svg" class="w-4 h-4" alt="" />
            }
          }
          {{ layout.headerAction()!.label }}
        </button>
      }
    </div>
  </div>
</header>
